"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Title = ({
  maxLines,
  titleVariant,
  title,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  if (!title) {
    return null;
  }
  const variantComponent = titleVariant ?? (isMobile ? 'h5' : 'h4');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DefaultTitle, {
    component: "h2",
    className: className,
    "data-testid": getTestId('title'),
    maxLines: maxLines,
    variant: variantComponent,
    children: title
  });
};
exports.Title = Title;
